import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/components/MainPage'
import ServiceProduct from '@/components/ServiceProduct'
import ServiceProductSupport from '@/components/ServiceProductSupport'
import bookVideo from '@/components/Video/bookVideo'
import chat from '@/components/Chat'
import serviceRequest from '@/components/ServiceProductRepair_ServiceRequest'
import requestwhereToGet from '@/components/Request_Where-to-get'
import whereDelivery from '@/components/Request_WhereDelivery'
import requestContact from '@/components/Request_Contact'
import requestSuccess from '@/components/Request_Success'
import tracking from '@/components/Tracking'
import cancel from '@/components/Cancel'
import cancelSuccess from '@/components/Cancel_Success'
import changeWhereToGet from '@/components/Change_Where-to-get'
import cancelWhereDelivery from '@/components/Change_WhereDelivery'
import brands from '@/components/Brands'
import videoinstruction from '@/components/VideoInstruction'
import videoSuccess from '@/components/Video/Video_Success'
import videoCansel from '@/components/Video/Video_Cansel'
import store from '../store'
import WarrantyPage from '../components/WarrantyPage'

Vue.use(Router)

export const router = new Router({
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
        // , offset: { x: 0, y: 10 }
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'MainPage',
      component: MainPage,
      children: [
        {
          path: 'brands',
          component: brands
        },
        {
          path: 'videoinstruction',
          name: 'VideoInstruction',
          component: videoinstruction
        }
      ]
    },
    {
      path: '/product',
      name: 'ServiceProduct',
      component: ServiceProduct,
      props: (route) => ({
        sn: route.query.sn
      })
    },
    {
      path: '/warranty',
      name: 'WarrantyProduct',
      component: WarrantyPage,
      props: (route) => ({
        sn: route.query.sn
      })
    },
    {
      path: '/service-product-support',
      name: 'ServiceProductSupport',
      component: ServiceProductSupport
    },
    {
      path: '/video',
      name: 'video',
      component: bookVideo,
      props: true
    },
    {
      path: '/video-success',
      name: 'video-success',
      component: videoSuccess,
      props: true
    },
    {
      path: '/video-cancel',
      name: 'video-cancel',
      component: videoCansel
    },
    {
      path: '/chat',
      name: 'chat',
      component: chat
    },
    {
      path: '/request',
      name: 'request',
      component: serviceRequest
    },
    {
      path: '/request_whereToGet',
      name: 'request_whereToGet',
      component: requestwhereToGet,
      beforeEnter: (to, from, next) => {
        if (!store.getters.getReasonComplete) next('/serviceRequest')
        else next()
      }
    },
    {
      path: '/whereDelivery',
      name: 'whereDelivery',
      component: whereDelivery,
      beforeEnter: (to, from, next) => {
        if (!store.getters.getReasonComplete) next('/serviceRequest')
        else next()
      }
    },
    {
      path: '/requestContact',
      name: 'requestContact',
      component: requestContact
      /*      beforeEnter: (to, from, next) => {
        if ((store.getters.getWhereToGetDelivery && store.getters.getWhereToGetComplete) || !store.getters.getWhereToGetDelivery) next()
        else next('/whereDelivery')
      }  */
    },
    {
      path: '/requestSuccess',
      name: 'requestSuccess',
      component: requestSuccess
    },
    {
      path: '/tracking',
      name: 'tracking',
      component: tracking,
      props: (route) => ({
        tn: route.query.tn
      })
    },
    {
      path: '/cancel',
      name: 'cancel',
      component: cancel
    },
    {
      path: '/cancelSuccess',
      name: 'cancelSuccess',
      component: cancelSuccess,
      props: true
    },
    {
      path: '/changeWhereToGet',
      name: 'changeWhereToGet',
      component: changeWhereToGet
    },
    {
      path: '/cancelWhereDelivery',
      name: 'cancelWhereDelivery',
      component: cancelWhereDelivery
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js